import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAddToBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAddToBasket2"><Path d="M8 3.5L6.09215 8.26963M16 3.5L17.9079 8.26963M11.5 20.5H4.5L2.5 8.5H21.5L20.8333 12.5M14.5 18.5H17.5M17.5 18.5H20.5M17.5 18.5V15.5M17.5 18.5V21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAddToBasket2;
